// The edit request that turns a copy of a vibe-coded tab into another
// language. It goes through the normal edit wrapper in AssistantVibeCoding, so
// it only says what to change. Nothing here assumes the copy is a game.
const translateCopyPrompt = (
    language: string
) => `Translate this into ${language}.

Change only the words a person using it sees or hears:
- text on the page, headings, buttons and labels
- placeholder, title, alt and aria-label attributes
- strings in the JavaScript that are shown on screen or read out (alerts, messages, labels, scores, instructions)

Leave everything else exactly as it is: names of variables, functions, ids, CSS classes, data keys, URLs and all of the logic. It must keep working exactly as before.

Also:
- set the lang attribute on <html> for ${language}${
    /arabic/i.test(language) ? ', and dir="rtl"' : ''
}
- make sure the fonts can show ${language}: keep the existing font first and add a system font fallback (for example system-ui, sans-serif)
- don't add, remove or rearrange anything else.`;

export default translateCopyPrompt;
